export const env = {
    public_key: 'KcCuI6_VwIs7iPDZ_',
    template_key: 'template_y276n3e',
    service_id: 'service_0lwtf39'
}